<ui-grid [data]="data$ | async"
         [loading]="loading$ | async"
         [selectable]="false"
         class="ui-robot-license-grid">

    <ui-grid-header [search]="true">
        <ui-header-button type="inline">
            <ng-template>
                <ui-grid-reset *ngIf="hasCustomFilters$ | async"
                               (reset)="resetFilter()"></ui-grid-reset>
            </ng-template>
        </ui-header-button>
    </ui-grid-header>

    <ui-grid-column [primary]="true"
                    [searchable]="true"
                    [sortable]="true"
                    [title]="'license_named_username' | translate"
                    [width]="isLicenseTypeAttended ? '50%' : '40%'"
                    property="userName">
        <ng-template let-entry="data">
            <ng-container *ngIf="entry.displayMachineNames.length > 0; else default">
                <span *ngLet="('license_named_username_format' | translate: {
                                    username: entry.userName,
                                    activeMachines: entry.displayMachineNames
                                }) as nameUserText"
                      [matTooltip]="nameUserText">
                    {{ nameUserText }}
                </span>
            </ng-container>
            <ng-template #default>
                <span [matTooltip]="entry.userName">
                    {{ entry.userName }}
                </span>
            </ng-template>
        </ng-template>
    </ui-grid-column>

    <ui-grid-column [title]="'license_named_last_login' | translate"
                    property="lastLogin"
                    width="13%">
        <ng-template let-entry="data">
            <ui-dateformat #lastLoginTimeFormat
                           [matTooltip]="lastLoginTimeFormat?.dataset['title']"
                           [date]="entry.lastLogin"
                           contentType="relative">
            </ui-dateformat>
        </ng-template>
    </ui-grid-column>

    <ui-grid-column [title]="'license_named_machines' | translate"
                    property="machines"
                    width="24%">
    </ui-grid-column>

    <ui-grid-column [title]="'license_named_status' | translate"
                    width="13%"
                    property="isLicensed"
                    sort="desc">
        <ng-template let-entry="data">
            <mat-icon [class.entry-status-active]="entry.isLicensed"
                      [class.entry-status-inactive]="!entry.isLicensed"
                      [matTooltip]="entry.isLicensed ?
                                ('named_license_status_active' | translate: {
                                    machines: entry.displayMachineNamesTooltip
                                }) :
                                ('named_license_status_offline' | translate)"
                      class="entry-status">fiber_manual_record</mat-icon>
        </ng-template>
        <ui-grid-dropdown-filter [items]="licensedFilterList">
        </ui-grid-dropdown-filter>
    </ui-grid-column>

    <ui-grid-column *ngIf="!isLicenseTypeAttended"
                    [title]="'license_named_external_license_source' | translate"
                    [sortable]="false"
                    property="source"
                    width="10%">
        <ng-template let-entry="data">
            {{ ('LicenseSource_' + LicenseFrontOfficeSource[entry.source]) | translate }}
        </ng-template>
        <ui-grid-dropdown-filter [items]="licenseSourceList">
        </ui-grid-dropdown-filter>
    </ui-grid-column>

    <ui-grid-row-action>
        <ng-template let-entry="data">
            <button [uiAuthorizeAnyDisable]="['Robots.View', 'Users.View']"
                    [routerLink]="['/user-activity']"
                    [queryParams]="encodeFilters({
                        'robot.userName': {
                            id:  entry.userName,
                            text:  entry.userName
                        },
                        'robot.type': getRobotType(licenseType)
                    })"
                    [matTooltip]="'license_named_grid_action_view_robots' | translate"
                    [uiClickTrack]="'Action: Grid: View Robots'"
                    mat-icon-button>
                <mat-icon svgIcon="uipath:ViewLogs"></mat-icon>
            </button>
        </ng-template>
    </ui-grid-row-action>

    <ui-grid-footer [length]="total$ | async"
                    [pageSize]="pageSize"
                    [pageSizes]="pageSizes">
    </ui-grid-footer>
</ui-grid>
